import {createListFromObject} from "../../Utilities/Types/listUtilities";

export const ROLES = {
    RmtcAdmin: 2,
    Patron: 5,
};

export const PATRON_ROLE = {
    Parent: 1,
    SchoolDistrictEmployee: 2,
    CharterSchoolEmployee: 3,
    PrivateSchoolEmployee: 4,
    Rmtc: 5,
    CollegeUniversity: 6,
    CommunityPartner: 7,
    DepartmentOfCorrections: 8,
    EarlyStepsPartCAgency: 9,
    Fsdb: 10,
    IdeaFundedStateProject: 11,
    StateAgency: 12,
};

export const PATRON_SUBTYPE = {
    HomeSchool: 1,
    Private: 2,
    Charter: 3,
    Public: 4,
    EseDirector: 5,
    Administrator: 6,
    Paraprofessional: 7,
    SchoolPsychologist: 8,
    Lats: 9,
    CollegeUniversityStudent: 10,
    CollegeUniversityFaculty: 11,
    StaffMember: 12,
    SchoolAdministrator: 13,
    None: 14,
    DhhItinerantTeacher: 15,
    DhhSelfContainedTeacher: 16,
    DhhSpecialist: 17,
    EducationalAudiologist: 18,
    EseTeacher: 19,
    GeneralEducationTeacher: 20,
    Interpreter: 21,
    SpeechLanguagePathologist: 22,
    TransitionSpecialist: 23,
    FsdbAdministration: 24,
    OccupationalTherapist: 25,
    PhysicalTherapist: 26,
    EarlyInterventionist: 27,
    PartCCoordinator: 28,
    AccessProject: 29,
    Arts4AllFlorida: 30,
    AuditoryOralEducationClarke: 31,
    AuditoryOralEducationMiami: 32,
    AutismTherapeuticWellness: 33,
    BridgeToSpeechClarke: 34,
    BridgeToSpeechMiami: 35,
    Card: 36,
    Chris: 37,
    CiviFsuFlvi: 38,
    Eip: 39,
    EseTuitionSupport: 40,
    FamilyCafe: 41,
    FdlrsACs: 42,
    FdlrsAdministration: 43,
    FdlrsMDCs: 44,
    FdlrsRlats: 45,
    Fin: 46,
    FimcVi: 47,
    FlpbisMtss: 48,
    IsrdC: 49,
    Ltl: 50,
    MiamiLighthouseAcademy: 51,
    Sednet: 52,
    SednetAdministration: 53,
    Pepsa: 54,
    Pdsp: 55,
    PsRtI: 56,
    PsRtITlc: 57,
    Pese: 58,
    Project10: 59,
    RmtcDhh: 60,
    SpecialOlympicsFlorida: 61,
    SssProject: 62,
    Wwe: 63,
};

export const PATRON_SUBTYPE_LIST = createListFromObject(PATRON_SUBTYPE);
